"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var Footer_1 = require("../components/Footer");
var common_1 = require("@shine-api/common");
var FooterContainer = function (_super) {
  __extends(FooterContainer, _super);
  function FooterContainer(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {};
    return _this;
  }
  FooterContainer.prototype.componentDidMount = function () {
    var _a = this.props,
      lat = _a.lat,
      lon = _a.lon;
    var savedFeedback = localStorage.getItem("ths_widget.feedback." + lat + "." + lon);
    if (savedFeedback) {
      this.setState(JSON.parse(savedFeedback));
    }
  };
  FooterContainer.prototype.feedback = function (areScoresUseful) {
    var _a = this.props,
      lat = _a.lat,
      lon = _a.lon;
    var event = areScoresUseful ? 'Thumbs up' : 'Thumbs down';
    localStorage.setItem("ths_widget.feedback." + lat + "." + lon, JSON.stringify({
      areScoresUseful: areScoresUseful
    }));
    common_1.track("Feedback - " + event, {
      lat: lat,
      lon: lon
    }, true);
    this.setState({
      areScoresUseful: areScoresUseful
    });
  };
  FooterContainer.prototype.render = function () {
    var _this = this;
    var areScoresUseful = this.state.areScoresUseful;
    var footerProps = areScoresUseful != null ? areScoresUseful ? {
      thumbsUp: 'selected',
      thumbsDown: ''
    } : {
      thumbsUp: '',
      thumbsDown: 'selected'
    } : {
      thumbsUp: '',
      thumbsDown: ''
    };
    return React.createElement(Footer_1.Footer, __assign({
      feedback: function feedback(usefulScores) {
        return _this.feedback(usefulScores);
      }
    }, footerProps));
  };
  return FooterContainer;
}(React.Component);
exports.FooterContainer = FooterContainer;